import breadcrumbSchema from '../schemas/breadcrumb';
import subListing from '../schemas/subListing';

const subTopicSchema = ({
  goal = {},
  topic = {},
  others = [],
  type,
  topicInfo,
  description
}) => {
  const graph = [];
  let breads = [
    {
      name: 'Explore',
      url: 'https://unacademy.com/explore'
    },
    {
      name: goal.name,
      url: goal.permalink
    },
    {
      name: 'Syllabus',
      url: `${goal.permalink}/topics`
    },
    { name: topic.name, url: topic.permalink }
  ];
  if (others.length > 0) {
    const moreBreadCrumbs = others.map(({ name, permalink }) => ({
      name,
      url: permalink
    }));
    breads = breads.concat(moreBreadCrumbs);
  }
  graph.push(breadcrumbSchema(breads));
  if (type === 'courses' && topicInfo) {
    graph.push(
      subListing({
        topic: goal.name,
        forPlus: true,
        name: `${goal.name} ${topicInfo.name}`,
        description,
        link: `https://unacademy.com/goal/${goal.slug}/${goal.uid}/topic/${topicInfo.uid}/courses`
      })
    );
  }
  const schema = {
    '@context': 'https://schema.org/',
    '@graph': graph
  };

  return schema;
};

export default subTopicSchema;
